<a mat-flat-button #projectButton [matMenuTriggerFor]="projectsMenu" #projectMenuTrigger="matMenuTrigger" (mouseenter)="projectButtonEnter()" (mouseleave)="projectButtonLeave()" style="z-index:1050;">Projects</a>
<mat-menu #projectsMenu="matMenu">
    <span (mouseenter)="projectMenuEnter()" (mouseleave)="projectMenuLeave()">
        <a mat-flat-button routerLink="projects/new-tab" appHoverFocus>New Tab Dashboard</a>
        <a mat-flat-button routerLink="projects/call-blocker" appHoverFocus>Android Call Blocker</a>
        <a mat-flat-button routerLink="projects/538-flipping" appHoverFocus>Riddler Puzzle - Coin Flipping</a>
    </span>
</mat-menu>